import { ProgramAttachmentItem } from '../types';

export function getFilenameFromUrl(url: string): string {
  try {
    const { pathname } = new URL(url);
    const objectPath = pathname.includes('/o/')
      ? decodeURIComponent(pathname.split('/o/')[1] || '')
      : decodeURIComponent(pathname);
    const name = objectPath.split('/').filter(Boolean).pop();
    return name || 'anexo';
  } catch {
    return 'anexo';
  }
}

export function mapUrlsToAttachmentItems(urls: string[] = []): ProgramAttachmentItem[] {
  return urls.map((url) => ({
    id: `${url}-${Math.random().toString(36).slice(2)}`,
    name: getFilenameFromUrl(url),
    url,
  }));
}

export async function urlToFile(url: string, filename?: string): Promise<File> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Não foi possível baixar o anexo ${filename || url}`);
  }

  const blob = await response.blob();
  const name = filename || getFilenameFromUrl(url);

  return new File([blob], name, { type: blob.type || 'application/octet-stream' });
}

export async function resolveAttachmentsToFiles(
  items: ProgramAttachmentItem[],
): Promise<File[]> {
  return Promise.all(
    items.map(async (item) => {
      if (item.file) {
        return item.file;
      }

      if (item.url) {
        return urlToFile(item.url, item.name);
      }

      throw new Error(`Anexo inválido: ${item.name}`);
    }),
  );
}
